import { amplitudeTrack } from '@cw-elements/analytics-provider';
import { getProviderType, persistedParam } from './track_auth';

/**
 * Amplitude events for the OTP code-verification screen: "verify user" (form
 * submit), "resend verification code" (Resend click), and "change
 * verification method" (switch-channel click, e.g. "use email instead").
 * "verify user" hooks the form's submit rather than the Continue button's
 * click: pressing Enter inside a filled code box submits the form directly,
 * bypassing the button (see the "pressing Enter" system spec), so a
 * click-only listener would miss that path.
 * Fires before the resulting navigation — mirrors track_auth.js's
 * fire-before-navigate pattern so the beacon transport can flush the queued
 * event on the resulting pagehide.
 */

// screen_state.channel is lowercase "sms"/"email"; screen_state.switch_target
// is uppercase "SMS"/"EMAIL" — both map to the same Amplitude enum values.
const CHANNEL_TO_METHOD = { sms: 'phone', email: 'email' };

export const verificationMethod = (channel) => CHANNEL_TO_METHOD[channel?.toLowerCase()];

const commonProperties = () => ({
  appId: persistedParam('client_id'),
  type: getProviderType(),
});

export const initTwoFactorEvents = () => {
  const form = document.getElementById('two-factor-verify-form');
  if (!form) return;

  const currentMethod = verificationMethod(form.dataset.channel);

  form.addEventListener('submit', () => {
    amplitudeTrack('verify user', { ...commonProperties(), 'verification method': currentMethod });
  });

  document.getElementById('two-factor-resend')?.addEventListener('click', () => {
    amplitudeTrack('resend verification code', {
      ...commonProperties(),
      'verification method': currentMethod,
    });
  });

  const switchButton = document.getElementById('two-factor-switch-channel');
  switchButton?.addEventListener('click', () => {
    amplitudeTrack('change verification method', {
      ...commonProperties(),
      'verification method': verificationMethod(switchButton.dataset.channel),
    });
  });
};
